module.exports = __webpack_public_path__ + "static/Banner2-fd564c5d96fae3d33de43f622124d423.jpg";